const samtykke = {
  knapper: {
    abort: {
      label: "Avbryt",
    },
    samtykke: {
      label: "Send kopi til fornærmet virksomhet",
    },
    close: {
      label: "Lukk",
    },
    send_inn: {
      try_again: "Prøv igjen",
      label: "Send inn",
    },
  },
  input: {
    samtykkeSvarType: {
      label:
        "Ønsker du å sende en kopi av din anmeldelse til fornærmet virksomhet?",
      type: {
        JA: "Ja",
        NEI: "Nei",
      },
    },
  },
  modal: {
    feiletInfo: "Noe gikk galt.",
    senderInn: "Lagrer svar",
    label: "Send svar",
    suksess: "Svar lagret",
  },
};
export default samtykke;
